<template>
  <div class="invest-result">
    <div>
      <div class="icon">
        <img src="@/assets/image/icons/icon-success.png">
      </div>
      <div class="title">
        {{ $t('title') }}
      </div>
      <div class="desc">
        {{ $t('desc') }}
      </div>
      <div class="button">
        <md-button type="primary" round @click="goToOverview">{{ $t('button') }}</md-button>
      </div>
    </div>
  </div>
</template>

<script>
import { Button } from 'mand-mobile'

export default {
  i18n: {
    messages: {
      en: {
        title: 'Congratulations!',
        desc: 'You have invested successfully',
        button: 'Go to My Account',
      },
      id: {
        title: 'Selamat!',
        desc: 'Anda telah berhasil mendanai',
        button: 'Masuk ke Akun Saya',
      },
    },
  },
  components: {
    [Button.name]: Button,
  },
  methods: {
    goToOverview() {
      this.$router.push({ name: 'UserOverview' })
    },
  },
}
</script>

<style scoped lang="stylus">
.invest-result {
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  padding: 0 50px 50px;
  background: #fff;
}

.icon {
  margin-bottom: 20px;
  img {
    width: 60px;
    height: 60px;
  }
}

.title {
  font-size: 22px;
  font-weight: 600;
  line-height: 1.25em;
  margin-bottom: 5px;
}

.desc {
  font-size: 14px;
  color: #555;
  margin-bottom: 38px;
}

.button /deep/ {
  .md-button {
    font-size: 16px;
  }
}
</style>
